export const ADMIN_CLIENT_DASHBOARD_PATH = "/dashboard"
export const isAdminClientViewUrl = (path: string) => path.includes(ADMIN_CLIENT_DASHBOARD_PATH)
